import { render, staticRenderFns } from "./reservat.vue?vue&type=template&id=63cc2fc7&scoped=true&"
import script from "./reservat.vue?vue&type=script&lang=js&"
export * from "./reservat.vue?vue&type=script&lang=js&"
import style0 from "./reservat.vue?vue&type=style&index=0&id=63cc2fc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc2fc7",
  null
  
)

export default component.exports